import React from 'react'
import { headCardHelp } from './headCardHelp'
import { WHATSAPP_API_URL } from 'app/constants'

type Props = {}

const useCardHelp = (props: Props) => {
  const [open, setOpen] = React.useState(false)
  
  const [message, setMessage] = React.useState(headCardHelp.placeholder)

  const href = `${WHATSAPP_API_URL}&text=${message}`

  return {
    open,
    setOpen,
    href,
    message,
    setMessage,
  }
}

export default useCardHelp